import { render, staticRenderFns } from "./step3_fromList.vue?vue&type=template&id=1e230a8b&"
import script from "./step3_fromList.vue?vue&type=script&lang=js&"
export * from "./step3_fromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports